<center>
    {{#SELECT selectedFields}}
    <select multiple="multiple" class="multi-select" id="{{elementId}}" name="{{elementName}}">
        <optgroup label="{{TR "Geräte Eigenschaften"}}">
        {{#each fields.device}}
            <option value="{{id}}">{{TR this.name}}</option>
        {{/each}}
        </optgroup>
        <optgroup label="{{TR "Daten"}}">
        {{#each fields.data}}
            <option value="{{id}}">{{TR this.name}}</option>
        {{/each}}
        </optgroup>
        <optgroup label="{{TR "Verwaltung"}}">
        {{#each fields.meta}}
            <option value="{{id}}">{{TR this.name}}</option>
        {{/each}}
        </optgroup>
    </select>
    {{/SELECT}}
</center>
